<div class="fpx-form-control">

    <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>

    <div class="fpx-field-content">
        <div class="amount-field-wrapper">
            <ng-container>
                <div class="currency-code-wrapper">
                    <span class="currency-code">{{ currencyCode }}</span>
                </div>
            </ng-container>

            <div class="amount-input">
                <input type="tel" inputmode="decimal" [mask]="amountMaskFormat" thousandSeparator="," matInput
                    [formControl]="formControl" separatorLimit="999999999" 
                    [ngClass]="{'input-available': formControl.value}" />

                <mat-placeholder *ngIf="placeholder" class="placeholder">{{ placeholder }}</mat-placeholder>
            </div>

        </div>
        <mat-error *ngIf="formControl.errors?.insufficentBal">Insufficient Balance</mat-error>
        <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
            {{ errorCode }}
        </mat-error>
    </div>

</div>